import { style } from 'styled-system';

export default style({ prop: 'gridRowStart' });
